import cn from "classnames";
import Select from "../Form/Select";
import TextInput from "../Form/TextInput";
import CheckboxForm from "../CheckboxForm";

const PropertyPricingSection = ({
  values,
  errors,
  touched,
  handleChange,
  styles,
  difference,
  router,
  generateYears,
  getRoomNumbers,
  propertyState,
  getFloors,
  getBathrooms,
}) => (
  <>
    <TextInput
      key={`form-input-propertySize`}
      values={values}
      formName="property_size"
      className={cn({
        [styles.editedObject]:
          difference.includes("property_size") &&
          router.includes("properties/edit"),
      })}
      handleChange={handleChange}
      type="number"
      placeholder={
        values["type"] === "form_input_lot"
          ? "Unesite povrsinu placa"
          : "Unesite kvadraturu"
      }
      label={
        values["type"] === "form_input_lot" ? "* Plac/m2" : "* Kvadratura/m2:"
      }
      errors={errors}
      touched={touched}
    />

    {values["type"] === "menu_houses" && (
      <TextInput
        key={`form-input-propertyLotSize`}
        values={values}
        formName="property_lot_size"
        className={cn({
          [styles.editedObject]:
            difference.includes("property_lot_size") &&
            router.includes("properties/edit"),
        })}
        handleChange={handleChange}
        type="number"
        placeholder="Unesite povrsinu placa"
        label="Plac/m2:"
        errors={errors}
        touched={touched}
      />
    )}

    <TextInput
      key={`form-input-price`}
      values={values}
      formName="price"
      className={cn({
        [styles.editedObject]:
          difference.includes("price") && router.includes("properties/edit"),
      })}
      type="number"
      handleChange={handleChange}
      placeholder="Unesite cenu"
      label="* Cena/€:"
      errors={errors}
      touched={touched}
    />

    {(values["type"] === "top_search_cat_menu_apartments" ||
      values["type"] === "menu_office") && (
      <CheckboxForm
        key={`form-checkbox-priceTax`}
        touched={touched}
        handleChange={handleChange}
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("price_tax") &&
            router.includes("properties/edit"),
        })}
        label="Cena sa PDV"
        formName="price_tax"
        values={values}
      />
    )}

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "form_input_garages" && (
        <Select
          key={`form-select-builtYear`}
          values={values}
          options={generateYears().map((year) => ({
            id: year,
            label: year,
          }))}
          className={cn({
            [styles.editedObject]:
              difference.includes("built_year") &&
              router.includes("properties/edit"),
          })}
          formName="built_year"
          handleChange={handleChange}
          placeholder="Izaberite godinu gradnje"
          label="Godina Gradnje:"
          errors={errors}
          touched={touched}
          ariaLabel="godina gradnje"
        />
      )}

    {values["type"] === "menu_houses" && (
      <CheckboxForm
        key={`form-input-showRoominess`}
        touched={touched}
        handleChange={handleChange}
        label="Prikazi sobnost"
        checkboxClass={cn({
          [styles.checkboxEdited]:
            difference.includes("show_roominess") &&
            router.includes("properties/edit"),
        })}
        formName="show_roominess"
        values={values}
      />
    )}

    {(values["type"] === "menu_houses" ||
      values["type"] === "top_search_cat_menu_apartments") && (
      <Select
        key={`form-select-rooms`}
        values={values}
        options={getRoomNumbers.map((room) => ({
          id: room.id,
          label: room.label || room.value,
        }))}
        formName="rooms"
        handleChange={handleChange}
        placeholder="Izaberite sobnost"
        className={cn({
          [styles.editedObject]:
            difference.includes("rooms") && router.includes("properties/edit"),
        })}
        label={values["type"] === "menu_houses" ? "Sobnost:" : "* Sobnost:"}
        errors={errors}
        touched={touched}
        ariaLabel="Sobnost"
      />
    )}

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "form_input_garages" && (
        <Select
          key={`form-select-propertyValue`}
          values={values}
          options={propertyState.map((st) => ({
            id: st.id,
            label: st.label,
          }))}
          formName="property_value"
          className={cn({
            [styles.editedObject]:
              difference.includes("property_value") &&
              router.includes("properties/edit"),
          })}
          handleChange={handleChange}
          placeholder="Izaberite stanje nekretnine"
          label="Stanje nekretnine:"
          errors={errors}
          touched={touched}
          ariaLabel="Stanje nekretnine"
        />
      )}

    <CheckboxForm
      key={`form-checkbox-propertyOfferLegal`}
      touched={touched}
      handleChange={handleChange}
      label="Uknjizena"
      formName="property_offer_legal"
      checkboxClass={cn({
        [styles.checkboxEdited]:
          difference.includes("property_offer_legal") &&
          router.includes("properties/edit"),
      })}
      values={values}
    />

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "menu_houses" &&
      values["type"] !== "form_input_garages" && (
        <>
          <Select
            key={`form-select-onFloor`}
            values={values}
            options={getFloors()}
            formName="on_floor"
            className={cn({
              [styles.editedObject]:
                difference.includes("on_floor") &&
                router.includes("properties/edit"),
            })}
            handleChange={handleChange}
            placeholder="Izaberite sprat"
            label="Sprat:"
            errors={errors}
            touched={touched}
            ariaLabel="Sprat"
          />
          <Select
            key={`form-select-totalFloors`}
            values={values}
            options={getFloors()}
            formName="total_floors"
            className={cn({
              [styles.editedObject]:
                difference.includes("total_floors") &&
                router.includes("properties/edit"),
            })}
            handleChange={handleChange}
            placeholder="Izaberite ukupno spratova"
            label="Ukupno spratova:"
            errors={errors}
            touched={touched}
            ariaLabel="Ukupno spratova"
          />
        </>
      )}

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "form_input_garages" && (
        <Select
          key={`form-select-propertyOfferBathroom`}
          values={values}
          options={getBathrooms()}
          formName="property_offer_bathroom"
          className={cn({
            [styles.editedObject]:
              difference.includes("property_offer_bathroom") &&
              router.includes("properties/edit"),
          })}
          handleChange={handleChange}
          placeholder="Izaberite broj kupatila"
          label="Broj kupatila:"
          errors={errors}
          touched={touched}
          ariaLabel="Broj kupatila"
        />
      )}
  </>
);

export default PropertyPricingSection;
